/* istanbul ignore file */
import React, { useMemo } from 'react';
import {
  FormCardDefaultHeader,
  FormCardBody,
  FormCard,
} from '@bingads-webui-fluent-component/form-cards';
import { AddRegular } from '@fluentui/react-icons';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { Button, mergeClasses, Body1Strong, Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useStyles, getSkeletonStyles } from './style';
import { ListItem } from './ListItem';
import { IListPanel } from './type';

const ListSkeleton = ({ maxCount }: { maxCount: number }) => {
  const classes = getSkeletonStyles();
  return (
    <Skeleton className={classes.row}>
      {Array(maxCount).fill('').map(() => <SkeletonItem className={classes.item} />)}
    </Skeleton>
  );
};

export const ListPanel = React.memo(({
  title,
  subTitle,
  text,
  errorMessage = '',
  images = [],
  isLoading,
  maxCount,
  showEditBtn = false,
  headerProps = {},
  helpTopic = '',
  helpLabel = '',
  onAdd,
  onEdit,
  onRemove,
}: IListPanel) => {
  const classes = useStyles();

  let displayedImages = images;
  if (displayedImages && maxCount && maxCount < images.length) {
    displayedImages = images.slice(0, maxCount);
  }

  const renderHelpBubble = useMemo(() => (
    <>
      {helpTopic && <HelpButton topic={helpTopic} aria-label={helpLabel} />}
    </>
  ), [helpLabel, helpTopic]);

  return (
    <FormCard error={errorMessage} className={mergeClasses('brandkit-list-panel', classes.listPanel)}>
      <FormCardDefaultHeader title={title} contentAfter={renderHelpBubble} {...headerProps} />
      <FormCardBody>
        <div className="list-body-header">
          <Body1Strong>{subTitle}</Body1Strong>
          {text && <p>{text}</p>}
        </div>
        {isLoading ?
          <ListSkeleton maxCount={maxCount} /> :
          <div className={mergeClasses('images-panel', classes.list)}>
            {displayedImages.map((data, idx) => (
              <ListItem showEditBtn={showEditBtn} key={data.Id} index={idx} imageData={data} onEdit={onEdit} onRemove={onRemove} />
            ))}
            {displayedImages?.length < maxCount && <Button
              icon={<AddRegular color="#0078D4" />}
              key="add_list"
              onClick={onAdd}
              className={mergeClasses(classes.addBtn, 'add_button')}
            />}
          </div>
        }
      </FormCardBody>
    </FormCard>
  );
});
